const STATISTICS = {
  CONVS_STATS_HEADER_TITLE: 'Conversations',
  PLATFORMS_STATS_HEADER_TITLE: 'Platforms',
  CONVS_STATS_HEADER_DESCRIPTION:
    'You can view the statistics of all conversations in different states (ended, accepted, etc.) by selecting the time frame you want inside the chart.',
  PLATFORMS_STATS_HEADER_DESCRIPTION:
    'You can view the statistics of all Platforms',
  CONVS_STATS_OVERALL_STATISTICS_TITLE: 'Total number of conversations',
  CONVS_STATS_CHART_SECTION_TITLE: 'Call statistics',
  CONVS_REPORT_BADGE_all_CONVS_TITLE: 'Conversations',
  CONVS_REPORT_BADGE_all_CONVS_DESC: 'conversations in the last week',
  CONVS_REPORT_BADGE_ENDED_TITLE: 'Ended conversations',
  CONVS_REPORT_BADGE_STARTED_TITLE: 'The conversation started by the operator',
  USERS_STATS_HEADER_TITLE: 'Users',
  USERS_STATS_HEADER_DESCRIPTION: 'You can view the statistics of all Users',

  //chart
  CONVS_CHART_LEGEND_ACCEPTED: 'Accepted conversations',
  CONVS_CHART_LEGEND_ENDED: 'Ended conversations',
  CONVS_CHART_LEGEND_CLOSED_AGENT: 'Unanswered conversations',
  CONVS_CHART_LEGEND_DENIED_CONVERSATION: 'Denied conversations',
  CONVS_CHART_LEGEND_NO_DATA: 'no data to display',

  CONVS_CHART_CHOOSING_TIME_PERIOD_LABEL: 'Time period',

  // Messages section in conversation stats page
  MESSAGES_HEADING_TITLE: 'Messages',
  MESSAGES_HEADING_DESCRIPTION:
    'This section is related to the statistics of the messages sent within the conversations; considering that it may take time to process the data related to the notices, you can send your request if you have not registered until the requested statistics are ready. See that.',
  ALL_MESSAGES_CARD_TITLE: 'Total number of messages exchanged',
  TEXT_MESSAGES_CARD_TITLE: 'Total number of text messages',
  IMAGE_MESSAGES_CARD_TITLE: 'Total number of photo-type messages',
  VIDEO_MESSAGES_CARD_TITLE: 'Total number of video messages',
  VOICE_MESSAGES_CARD_TITLE: 'Total number of voice messages',
  FILE_MESSAGES_CARD_TITLE: 'Total number of letters of type file',
  MESSAGE_CARD_COUNT_TITLE: 'Number',
  MESSAGE_CARD_PERCENT_RATE_TITLE: 'Growth',
  MESSAGES_CHART_HORIZONTAL_LABEL: 'Number',
  AREA_CHART_DEFAULT_OOUNT_LABEL: 'Count',

  TOTAL_PLATFORMS: 'Total',
  WEB_USERS: 'Web Users: ',
  MOBILE_USERS: 'Mobile Users: ',
  MONTH: 'Month',
  DAY: 'Day',
  HOUR: 'Hour',

  POPULAR_BROWSER: 'Popular Browser',
  PLATFORM_KEYWORD: 'Platform',
  USER_KEYWORD: 'Users Statistics',

  BROWSER_STATS_TITLE: 'Browser Statistics',
  OS_STATS_TITLE: 'OS Statistics',
  USER_UNIT: 'Users',

  CHROME: 'Chrome',
  FIREFOX: 'Firefox',
  SAFARI: 'Safari',
  OPERA: 'Opera',
  WINDOWS: 'Windows',
  LINUX: 'LINUX',
  MAC: 'Mac',
  IOS: 'ios',
  ANDROID: 'Android',

  MAX_USERS_DAY_NIGHT: 'Max Users in Day: ',
  MAX_USERS_HOUR: 'Max Users in hour: ',

  // excel export modal
  EXCEL_EXPORT_MODAL_HEADER_TITLE: 'Get excel export',
  EXCEL_EXPORT_MODAL_DESC:
    'Choose type of messages you want to be in the export',
  EXCEL_EXPORT_MODAL_PERIOD_LABEL: 'Time period',
  EXCEL_EXPORT_MODAL_WEBSITE_LABEL: 'Website',
  EXCEL_EXPORT_MODAL_TEXT_MSG: 'Text message',
  EXCEL_EXPORT_MODAL_IMG_MSG: 'Image message',
  EXCEL_EXPORT_MODAL_VIDEO_MSG: 'Video message',
  EXCEL_EXPORT_MODAL_AUDIO_MSG: 'Audio message',
  EXCEL_EXPORT_MODAL_FILE_MSG: 'File message',
  EXCEL_EXPORT_MODAL_FOOTER_CANCEL: 'Cancel',
  EXCEL_EXPORT_MODAL_FOOTER_SUBMIT: 'Get export',
  EXCEL_EXPORT_MODAL_SEND_EMAIL_TOAST:
    'Export will be sent to your email address',
  EXCEL_EXPORT_MODAL_CHOOSE_WEBSITE_TOAST_WARN: 'Please choose website',
  EXCEL_EXPORT_MODAL_CHOOSE_MESSAGE_TYPE_TOAST_WARN:
    'Please choose at least one message type',
  EXCEL_EXPORT_MODAL_MAX_LIMIT_WARN: 'You can get export at most 2 times a day',
  EXCEL_EXPORT_PROBLEM_SUBMITING_MSG:
    'There is a problem submiting your request! Please try again.',
  EXCEL_EXPORT_NO_REQUEST_SUBMITED_MSG:
    'There is no request submited for this time period !',
  EXCEL_EXPORT_WHAIT_FOR_PROCESS_MSG:
    'Please wait your request is being processed!',
  EXCEL_EXPORT_NO_REQEST_CHOOSE_PERIOD_P_1: 'Are you willing for the period',
  EXCEL_EXPORT_NO_REQEST_CHOOSE_PERIOD_P_2: 'to',
  EXCEL_EXPORT_NO_REQEST_CHOOSE_PERIOD_P_3: 'submit your request?',
  SEND_REQUEST: 'submit',
};

export default STATISTICS;
